import React from "react";
import "./Sidebar.css";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { canAccess } from "../../config/access";

interface SidebarProps {
  collapsed: boolean;
  onToggle: () => void;
}

interface NavItem {
  label: string;
  path: string;
  icon: string;
  roles: string[];
}

const navItems: NavItem[] = [
  { label: "Dashboard", path: "/dashboard", icon: "📊", roles: ["sales_rep", "sales_manager", "admin"] },
  { label: "Practice", path: "/practice", icon: "🎭", roles: ["sales_rep", "sales_manager", "admin"] },
  { label: "Coaching", path: "/coaching", icon: "🎯", roles: ["sales_rep", "sales_manager", "admin"] },
  { label: "Learn", path: "/learn", icon: "📱", roles: ["sales_rep", "sales_manager", "admin"] },
  { label: "Team", path: "/team", icon: "👥", roles: ["sales_manager", "admin"] },
  { label: "Settings", path: "/settings", icon: "⚙️", roles: ["admin"] },
];

export function Sidebar({ collapsed, onToggle }: SidebarProps) {
  const { role } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const visibleItems = navItems.filter((item) => canAccess(role, item.roles));

  return (
    <aside className={`protrain-sidebar ${collapsed ? "protrain-sidebar--collapsed" : ""}`}>
      <button className="protrain-sidebar-toggle" onClick={onToggle} aria-label="Toggle sidebar">
        {collapsed ? "→" : "←"}
      </button>
      <nav className="protrain-sidebar-nav">
        {visibleItems.map((item) => (
          <button
            key={item.path}
            className={`protrain-sidebar-item ${location.pathname === item.path ? "protrain-sidebar-item--active" : ""}`}
            onClick={() => navigate(item.path)}
            title={item.label}
          >
            <span className="protrain-sidebar-icon">{item.icon}</span>
            {!collapsed && <span className="protrain-sidebar-label">{item.label}</span>}
          </button>
        ))}
      </nav>
    </aside>
  );
}
